<template>
  <div>
    <el-card style="height:450px;">
      <div slot="header">
        <span>任务类型分布</span>
        <el-select
          @change="onPeriodChange"
          v-model="dtPeriod"
          placeholder="请选择"
          size="mini"
          class="top-selector"
        >
          <el-option
            v-for="period in dtPeriodList"
            :key="period.key"
            :label="period.text"
            :value="period.key"
          ></el-option>
        </el-select>
        <el-select
          @change="onTypeChange"
          v-model="dtType"
          placeholder="请选择"
          size="mini"
          class="top-selector"
        >
          <el-option
            v-for="type in dtTypeList"
            :key="type.key"
            :label="type.text"
            :value="type.key"
          ></el-option>
        </el-select>
      </div>
      <div id="taskStatDashboard" style="width:100%;height:400px;"></div>
    </el-card>
  </div>
</template>

<script>
import { GetTaskStatsGroupByTaskType } from "@/api/modules/basicData/task.js";
let echarts = require("echarts");
export default {
  name: "TaskStatDashboard",
  data() {
    return {
      dtType: "0",
      dtPeriod: "0",
      dtTypeList: [
        { key: "0", text: "创建时间" },
        { key: "1", text: "接收时间" },
        { key: "2", text: "完成时间" }
      ],
      dtPeriodList: [
        { key: "0", text: "最近7天" },
        { key: "1", text: "最近15天" },
        { key: "2", text: "最近30天" },
        { key: "3", text: "最近6个月" },
        { key: "4", text: "最近1年" }
      ],
      request:{}
    };
  },
  methods: {
    draw(titles, values) {
      let dom = document.getElementById("taskStatDashboard");
      if(!dom){
        return;
      }
      let myChart = echarts.init(dom);
      let option = {
        title: {
          show: false
        },
        tooltip: {},
        itemStyle: {
          color: "#409EFF"
        },
        legend: {
          data: ["任务数量"]
        },
        xAxis: {
          data: titles
        },
        yAxis: {},
        series: [
          {
            name: "数量",
            type: "bar",
            data: values
          }
        ]
      };
      myChart.setOption(option);
    },
    refresh(request) {
      this.request=request;
      GetTaskStatsGroupByTaskType({
        TimeType: this.dtType,
        TimeRange: this.dtPeriod,
        UserId: request.UserId,
        TaskIds: request.TaskIds || "",
        Paras: request.Paras || {},
        ServerCenterId: request.ServerCenterId || ""
      })
        .then(res => {
          let titles = [];
          let values = [];
          if (res && res.length > 0) {
            titles = res.map(task => task.Name);
            values = res.map(task => task.Value);
          }
          this.draw(titles, values);
        })
        .catch(error => {
          console.log(error);
          // this.$message.error("获取统计数据失败");
        });
    },
    onPeriodChange(period) {
      this.refresh(this.request);
    },
    onTypeChange(type) {
      this.refresh(this.request);
    }
  }
};
</script>

<style lang="less" scoped>
#taskStatDashboard {
  margin-top: -20px;
}
.top-selector {
  margin-top: -4px;
  margin-left: 12px;
  width: 100px;
  float: right;
}
</style>
